import { render } from "./OrderItemListItem.vue?vue&type=template&id=0de17ab6&scoped=true"
import script from "./OrderItemListItem.vue?vue&type=script&lang=js"
export * from "./OrderItemListItem.vue?vue&type=script&lang=js"

import "./OrderItemListItem.vue?vue&type=style&index=0&id=0de17ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de17ab6"]])

export default __exports__